import { render, staticRenderFns } from "./FaqAnswer.vue?vue&type=template&id=65cecd45&scoped=true&"
import script from "./FaqAnswer.vue?vue&type=script&lang=js&"
export * from "./FaqAnswer.vue?vue&type=script&lang=js&"
import style0 from "./FaqAnswer.vue?vue&type=style&index=0&id=65cecd45&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cecd45",
  null
  
)

export default component.exports